<template>
  <div class="trainingCamp-enroll-partners" v-loading="loading">
    <div class="head">{{`${roleMap[role]}报名表`}}</div>
    <el-form ref="form" :model="form" :rules="rules" label-width="135px">
      <div class="form-inner">
        <el-form-item label="1.您的姓名" prop="name">
          <el-input v-model.trim="form.name" :maxlength="99"></el-input>
        </el-form-item>
        <el-form-item label="2.您的身份证号" prop="idCard">
          <el-input v-model.trim="form.idCard" :maxlength="50"></el-input>
          <p class="camp-desc">说明：用户万米跑购买保险</p>
        </el-form-item>
        <el-form-item label="3.联系方式" prop="phone">
          <el-input v-model.trim="form.phone" :maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="4.性别" prop="sex">
          <el-radio-group v-model="form.sex">
            <el-radio v-for="(item, index) in option.sex" :key="index" :label="item">{{item}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="5.饮食要求" prop="eatType">
          <el-radio-group v-model="form.eatType">
            <el-radio v-for="(item, index) in option.eatType" :key="index" :label="item">{{item}}</el-radio>
          </el-radio-group>
        </el-form-item>

        <template v-if="role===0">
          <el-form-item label="6.是否有授课经验" prop="teachingExperience">
            <el-radio-group v-model="form.teachingExperience">
              <el-radio v-for="(item, index) in option.teachingExperience" :key="index" :label="item">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="7.教育背景" prop="teachingBackground">
            <el-radio-group v-model="form.teachingBackground">
              <el-radio v-for="(item, index) in option.teachingBackground" :key="index" :label="item">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="8.衣服尺码" prop="clothesSize">
            <el-radio-group v-model="form.clothesSize">
              <el-radio v-for="(item, index) in option.clothesSize" :key="index" :label="item">{{item}}</el-radio>
            </el-radio-group>
            <p class="camp-desc">说明：共创营文化衫</p>
          </el-form-item>
          <el-form-item label="9.主营科目" prop="mainSubject">
            <el-checkbox-group v-model="form.mainSubject">
              <el-checkbox v-for="(item, index) in option.mainSubject" :key="index" :label="item"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="10.招生人次" prop="studentNum">
            <el-radio-group v-model="form.studentNum">
              <el-radio v-for="(item, index) in option.studentNum" :key="index" :label="item">{{item}}</el-radio>
            </el-radio-group>
            <p class="camp-desc">人次：当期课各学科在读的学员总和</p>
          </el-form-item>
          <el-form-item label="11.校区数量" prop="schoolNum">
            <el-input-number v-model="form.schoolNum" controls-position="right" :min="0" :max="99999999"></el-input-number>
          </el-form-item>
          <el-form-item label="12.过往工作经历" class="line-height-20" prop="workExperience">
            <el-input v-model.trim="form.workExperience" type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" show-word-limit :maxlength="500"></el-input>
          </el-form-item>
          <el-form-item label="13.您在办学中面临的困难有哪些" class="line-height-20" prop="difficulty">
            <el-input v-model.trim="form.difficulty" type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" show-word-limit :maxlength="500"></el-input>
          </el-form-item>
          <el-form-item label="14.希望在本次共创营中学习的内容" class="line-height-20" prop="hopeStudy">
            <el-input v-model.trim="form.hopeStudy" :autosize="{ minRows: 2, maxRows: 6 }" show-word-limit type="textarea" :maxlength="500"></el-input>
          </el-form-item>
        </template>

        <template v-if="role===1||role===2">
          <el-form-item label="6.衣服尺码" prop="clothesSize">
            <el-radio-group v-model="form.clothesSize">
              <el-radio v-for="(item, index) in option.clothesSize" :key="index" :label="item">{{item}}</el-radio>
            </el-radio-group>
            <p class="camp-desc">说明：共创营文化衫</p>
          </el-form-item>
          <el-form-item label="7.是否带课" prop="hasCourse">
            <el-radio-group v-model="form.hasCourse" @change="handleChangeHasCourse">
              <el-radio v-for="(item, index) in option.hasCourse" :key="index" :label="item">{{item}}</el-radio>
            </el-radio-group>
            <div class="hasCourse">
              <p class="hasCourse-label">年级</p>
              <el-checkbox-group v-model="form.grades" :disabled="form.hasCourse!=='是'">
                <el-checkbox v-for="(item, index) in option.grades" :key="index" :label="item"></el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="hasCourse">
              <p class="hasCourse-label">学科</p>
              <el-checkbox-group v-model="form.subjects" :disabled="form.hasCourse!=='是'">
                <el-checkbox v-for="(item, index) in option.subjects" :key="index" :label="item"></el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
        </template>

        <template v-if="role===1">
          <el-form-item label="8.您在校现任职务" prop="nowJob">
            <el-input v-model.trim="form.nowJob" :maxlength="99"></el-input>
          </el-form-item>
          <el-form-item label="9.您机构的招生方式" class="line-height-20" prop="schoolEnrollType">
            <el-input v-model.trim="form.schoolEnrollType" type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" show-word-limit :maxlength="500"></el-input>
          </el-form-item>
          <el-form-item label="10.您怎么看待双师项目" class="line-height-20" prop="shuangshiIdea">
            <el-input v-model.trim="form.shuangshiIdea" type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" show-word-limit :maxlength="500"></el-input>
          </el-form-item>
        </template>

        <template v-if="role===2">
          <el-form-item label="8.带课年限" prop="hasCourseYear">
            <el-radio-group v-model="form.hasCourseYear">
              <el-radio v-for="(item, index) in option.hasCourseYear" :key="index" :label="item">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="9.您在校现任职务" prop="nowJob">
            <el-input v-model.trim="form.nowJob" :maxlength="99"></el-input>
          </el-form-item>
        </template>

        <div class="bottom">
          <el-button type="primary" @click="handleSubmit">提交</el-button>
        </div>
      </div>
    </el-form>
    <el-dialog
      :title="dialogInfo[resultStatus].title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="420px"
     @close="handleDialogClose"
    >
      <div class="dialog-con">
        <img :src="dialogInfo[resultStatus].img" alt="result">
        <p>{{ dialogInfo[resultStatus].p }}</p>
        <span>{{ dialogInfo[resultStatus].span }}</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" style="width:102px" @click="dialogVisible = false">返回首页</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apiTrainingCamp from '@/services/trainingCamp.js'
import AreaSelect from '../../components/areaSelect'
import { getUser } from '@/utils/auth'
// import identityCodeValid from '@/utils/IdentityCodeValid.js'
export default {
  data () {
    const validatePhone = (rule, value, callback) => {
      let str = value.replace(/\s*/g, '')
      let reg = /^1[0-9]{10}$/
      const result = reg.test(str)
      if (!result) {
        callback(new Error('您输入的手机号码有误，请检查后重新输入'))
      } else {
        let arr = str.split('')
        arr.splice(3, 0, ' ')
        arr.splice(8, 0, ' ')
        this.form.phone = arr.join('')
        callback()
      }
    }
    const validateidCard = (rule, value, callback) => {
      let str = value.replace(/\s*/g, '')
      const regIdCard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      const result = regIdCard.test(str)
      if (!result) {
        callback(new Error('您输入的身份证号有误，请检查后重新输入'))
      } else {
        let arr = str.split('')
        arr.splice(6, 0, ' ')
        arr.splice(11, 0, ' ')
        if (arr.length === 20) {
          arr.splice(16, 0, ' ')
        }
        this.form.idCard = arr.join('')
        callback()
      }
    }
    const validateidHasCourse = (rule, value, callback) => {
      if (this.form.hasCourse === '是') {
        if (!this.form.subjects.length) {
          callback(new Error('请选择学科'))
        } else if (!this.form.grades.length) {
          callback(new Error('请选择年级'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      loading: false,
      dialogVisible: false,
      resultStatus: 'success',
      dialogInfo: {
        success: {
          title: '报名成功',
          p: '钉钉扫描上方二维码，立即加入该群',
          span: '快来加入吧',
          img: ''
        },
        fail: {
          title: '报名失败',
          p: '抱歉！您访问的表单报名名额已满备份',
          span: '感谢您的关注',
          img: require('./image/result.png')
        }
      },
      // isRole1CanEnroll: false,
      role: '', // 0校长、1主管、2辅导老师,
      roleMap: ['校长', '主管', '辅导老师'],
      campsName: '',
      form: {
        name: '',
        phone: '',
        idCard: '',
        sex: '',
        eatType: '',
        teachingExperience: '',
        teachingBackground: '',
        clothesSize: '',
        mainSubject: [],
        studentNum: '',
        hasCourse: '',
        subjects: [],
        grades: [],
        hasCourseYear: '',
        schoolNum: 0,
        workExperience: '',
        difficulty: '',
        hopeStudy: '',
        nowJob: '',
        schoolEnrollType: '',
        shuangshiIdea: ''
      },
      option: {
        sex: ['男', '女'],
        eatType: ['清真', '非清真'],
        teachingExperience: ['是', '否'],
        teachingBackground: ['专科', '本科', '研究生', '博士', '其它'],
        clothesSize: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL'],
        mainSubject: ['K12', '艺术', '托管', '少儿英语', '其它'],
        studentNum: ['新机构', '0-100', '100-500', '500-2000', '2000以上'],
        hasCourse: ['否', '是'],
        subjects: ['数学', '语文', '英语', '其它'],
        grades: ['学前', '小学', '初中', '高中'],
        hasCourseYear: ['新手', '1-2年', '2-4年', '4年以上']
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: validateidCard, trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        eatType: [
          { required: true, message: '请选择饮食要求', trigger: 'change' }
        ],
        teachingExperience: [
          { required: true, message: '请选择授课经验', trigger: 'change' }
        ],
        teachingBackground: [
          { required: true, message: '请选择教育背景', trigger: 'change' }
        ],
        clothesSize: [
          { required: true, message: '请选择培训服尺寸', trigger: 'change' }
        ],
        mainSubject: [
          { type: 'array', required: true, message: '请选择主营科目', trigger: 'change' }
        ],
        studentNum: [
          { required: true, message: '请选择招生人次', trigger: 'change' }
        ],
        hasCourse: [
          { required: true, message: '请选择带课', trigger: 'change' },
          { validator: validateidHasCourse, trigger: 'change' }
        ],
        hasCourseYear: [
          { required: true, message: '请选择带课年限', trigger: 'change' }
        ],
        schoolNum: [
          { type: 'number', required: true, message: '请输入校区数量', trigger: 'blur' }
        ],
        workExperience: [
          { required: true, message: '请输入过往工作经历', trigger: 'blur' }
        ],
        difficulty: [
          { required: true, message: '请输入您在办学中面临的困难有哪些', trigger: 'blur' }
        ],
        hopeStudy: [
          { required: true, message: '请输入希望在本次共创营中学习的内容', trigger: 'blur' }
        ],
        nowJob: [
          { required: true, message: '请输入您在校现任职务', trigger: 'blur' }
        ],
        schoolEnrollType: [
          { required: true, message: '请输入您机构的招生方式', trigger: 'blur' }
        ],
        shuangshiIdea: [
          { required: true, message: '请输入您怎么看待双师项目', trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    AreaSelect
  },
  created () {
    this.campsName = decodeURIComponent(this.$route.query.campsName)
    this.role = parseInt(this.$route.query.role)
    this.schoolId = this.$route.query.schoolId
    this.campsId = this.$route.query.campsId
    this.recordId = this.$route.query.id
    // this.getCreateLoadOptions()
    // this.postCheckIsCanEnroll()

    this.role0Map = ['teachingExperience', 'teachingBackground', 'mainSubject', 'studentNum', 'schoolNum', 'workExperience', 'difficulty', 'hopeStudy']
    this.role1Map = ['hasCourse', 'subjects', 'grades', 'nowJob', 'schoolEnrollType', 'shuangshiIdea']
    this.role2Map = ['hasCourse', 'hasCourseYear', 'subjects', 'grades', 'nowJob']
  },
  methods: {
    // getCreateLoadOptions () {
    //   this.loading = true
    //   apiTrainingCamp.createLoadOptions({}).then((res) => {
    //     this.loading = false
    //     if (res.ok) {
    //       const ind = res.data.roleMap.findIndex((item) => { return item.value === 2 })
    //       res.data.roleMap.splice(ind, 1)
    //       this.optionsMap = res.data
    //     }
    //   })
    // },
    // postCheckIsCanEnroll () {
    //   apiTrainingCamp.checkIsCanEnroll({schoolId: this.schoolId}).then((res) => {
    //     if (res.ok) {
    //       this.isRole1CanEnroll = res.data === 'true'
    //     }
    //   })
    // },
    handleChangeHasCourse (val) {
      if (val === '否') {
        this.form.subjects = []
        this.form.grades = []
      }
    },
    handleSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm('是否继续提交？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.setParamsCreate()
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消创建'
            })
          })
        } else {
          this.$message({
            type: 'error',
            message: '表单填写有误，请检查后重新输入'
          })
          return false
        }
      })
    },
    setParamsCreate () {
      const params = {}
      params['cooperation'] = getUser().cooperation_type
      params['role'] = this.role
      params['schoolId'] = this.schoolId
      params['campsId'] = this.campsId
      params['id'] = this.recordId
      params['phone'] = this.form.phone.replace(/\s*/g, '')
      params['idCard'] = this.form.idCard.replace(/\s*/g, '')
      params['name'] = this.form.name
      params['sex'] = this.form.sex
      params['eatType'] = this.form.eatType
      params['clothesSize'] = this.form.clothesSize
      if (this.role === 0) {
        this.role0Map.forEach((key) => {
          if (key === 'mainSubject') {
            params['mainSubject'] = JSON.stringify(this.form['mainSubject'])
          } else {
            params[key] = this.form[key]
          }
        })
      }
      if (this.role === 1) {
        this.role1Map.forEach((key) => {
          if (key === 'subjects' || key === 'grades') {
            params[key] = JSON.stringify(this.form[key])
          } else {
            params[key] = this.form[key]
          }
        })
      }
      if (this.role === 2) {
        this.role2Map.forEach((key) => {
          if (key === 'subjects' || key === 'grades') {
            params[key] = JSON.stringify(this.form[key])
          } else {
            params[key] = this.form[key]
          }
        })
      }
      this.postCreate(params)
    },
    postCreate (params) {
      const that = this
      apiTrainingCamp.create(params).then((res) => {
        if (res.ok && res.data) {
          this.$message({
            duration: 1000,
            type: 'success',
            message: '提交成功',
            onClose () {
              that.dialogVisible = true
              that.resultStatus = 'success'
              that.dialogInfo.success.img = res.data.groupQrcodeUrl
            }
          })
        }
        if (res.ok && (res.code === 100)) {
          this.$message({
            duration: 2000,
            type: 'error',
            message: '提交失败',
            onClose () {
              that.dialogVisible = true
              that.resultStatus = 'fail'
            }
          })
        }
      })
    },
    handleDialogClose () {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scope>
.trainingCamp-enroll-partners {
  margin: 0 auto;
  width: 720px;
  background-color: #FFFFFF;
  box-shadow:0px 2px 4px 0px rgba(0,0,0,0.06);
  border-radius:3px;
  border:1px solid rgba(229,229,229,1);
  .head {
    height: 90px;
    line-height: 90px;
    text-align: center;
    font-weight: 600;
    font-size: 22px;
    color: #FFFFFF;
    background-color: #0182FF;
  }
  .form-inner {
    padding: 8px 51px 50px 36px;
  }
  /deep/ .el-form-item {
    margin-top: 38px;
    // text-align-last: left;
  }
  /deep/ .el-form-item__label {
    font-weight: 500;
    color: #2A2B2D;
    vertical-align: middle;
  }
  /deep/ .el-input__count {
    line-height: normal;
  }
  .line-height-20 {
    /deep/ .el-form-item__label {
       line-height: 20px;
    }
  }
  .hasCourse {
    display: flex;
    .hasCourse-label {
      margin-right: 14px;
      color: #9A9A9A;
      font-size: 14px;
    }
  }
  // .el-tutor-iphone {
  //   .el-form-item__label {
  //     &::after {
  //       content: '（辅导老师手机号会关联上课账号，请务必正确填写）';
  //       color: red;
  //     }
  //   }
  // }
  // .el-radio, .el-checkbox {
  //   display: block;
  //   line-height: 20px;
  //   height: 20px;
  // }
  // .el-radio+.el-radio, .el-checkbox+.el-checkbox {
  //   margin-left: 0px;
  //   margin-top: 10px;
  // }
  .camp-desc {
    line-height: 17px;
    font-size: 12px;
    color: #B1B1B1;
  }
  .bottom {
    display: flex;
    justify-content: center;
    margin-top: 54px;
    .el-button {
      width: 180px;
    }
  }
  .dialog-con {
    padding-top: 10px;
    padding-bottom: 20px;
    text-align: center;
    img {
      height: 230px;
      margin-bottom: 24px;
    }
  }
  .dialog-footer {
    text-align: center;
  }
}

</style>
